import { IStore } from '../../store';
import { TORB1Actions } from './actions';
import { IAuthActions } from '../auth/actions';
import createMiddleware from '../../_core/create-middleware';
import orb1HistoryMiddleware from './middlewares/history.middleware';

const orb1BaseMiddleware = createMiddleware<
    IStore,
    TORB1Actions | IAuthActions
>()
    .getMiddleware();

const orb1Middlewares = [
    orb1BaseMiddleware,
    orb1HistoryMiddleware,
];

export default orb1Middlewares;
